import React from "react";

const BaseFormContext = React.createContext(null);
export function BaseFormProvider({ children, ...props }) {
  return (
    <BaseFormContext.Provider value={props}>
      {children}
    </BaseFormContext.Provider>
  );
}

export function useBaseFormCtx() {
  return React.useContext(BaseFormContext);
}
